export enum GoogleAnalyticsEvents {
  REV_HUB_PRODUCT_CODE = 'rev_hub_product_code',
  PURCHASE = 'purchase',
  BEGIN_CHECKOUT = 'begin_checkout',
  AUDIO_PLAY = 'audio_play',
  VIDEO_VIEW = 'video_view',
}

export enum GoogleAnalyticsPaths {
  REV_HUB_PRODUCT_CODE = 'rev_hub_product_code',
  ORDER_COMPLETE = 'order_complete',
}
